module.exports = __webpack_public_path__ + "img/bold-icon next.8213ddd3.svg";